import { render, staticRenderFns } from "./RiderDisciplineIndex.vue?vue&type=template&id=f4dfb4b8&lang=pug"
import script from "./RiderDisciplineIndex.vue?vue&type=script&lang=js"
export * from "./RiderDisciplineIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports